import { render, staticRenderFns } from "./HistorySgpDetail.vue?vue&type=template&id=ac957fd6"
import script from "./HistorySgpDetail.vue?vue&type=script&lang=js"
export * from "./HistorySgpDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports